'use client';
// Keep the project's import names; implementations and lazy boundary are shared.
export {
  AddToCartDialog as CartConfirmationDialog,
  AddToCartVariantDialog as CartVariantDialog,
} from '@eliadmin/core/src/components/dialog/lazy-dialogs';
